import { PlanView, useProductionPlanQueryParams } from '../hooks';
import { GanttSearchResults } from './GanttSearchResults';
import { KanbanSearchResults } from './KanbanSearchResults';
import { SearchAbove } from './SearchAbove';

type SearchResultsProps = {
  search: string;
};

export const SearchResults = ({ search }: SearchResultsProps) => {
  const {
    queryParams: { view },
  } = useProductionPlanQueryParams();

  if (!search.length) {
    return <SearchAbove />;
  }

  if (view === PlanView.KANBAN) {
    return <KanbanSearchResults search={search} />;
  }

  return <GanttSearchResults search={search} />;
};
